class BmExitPopup extends HTMLElement {
  connectedCallback() {
    this.dismissKey = 'bm-exit-popup-shown';
    this.hasShown = false;

    try {
      if (sessionStorage.getItem(this.dismissKey) === '1') {
        this.hasShown = true;
      }
    } catch (e) {}

    this.querySelectorAll('[data-bm-exit-close]').forEach((el) => {
      el.addEventListener('click', () => this.close());
    });
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && !this.hasAttribute('hidden')) this.close();
    });

    if (this.hasShown) return;

    // Desktop: mouse leaves toward the top of the viewport.
    document.addEventListener('mouseout', (e) => {
      if (this.hasShown) return;
      if (e.clientY > 0) return;
      if (!e.relatedTarget && !e.toElement) this.open();
    });

    // Mobile / fallback: no reliable exit signal, so use a generous time delay.
    this._fallbackTimer = setTimeout(() => this.open(), 45000);
  }

  open() {
    if (this.hasShown) return;
    this.hasShown = true;
    clearTimeout(this._fallbackTimer);
    try { sessionStorage.setItem(this.dismissKey, '1'); } catch (e) {}
    this.removeAttribute('hidden');
    document.body.style.overflow = 'hidden';
    const input = this.querySelector('input[type="email"]');
    if (input) setTimeout(() => input.focus(), 100);
  }

  close() {
    this.setAttribute('hidden', '');
    document.body.style.overflow = '';
  }
}

customElements.define('bm-exit-popup', BmExitPopup);
